import { render } from "./Services.vue?vue&type=template&id=637a08ce&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=637a08ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-637a08ce"

export default script